document.addEventListener("DOMContentLoaded", () => {
    const currentDate = new Date();
    const discountEndDate = new Date("2026-02-15T23:59:59");
    if (currentDate > discountEndDate) return;

    // const lastPopupShown = localStorage.getItem("sandsLastPopupShown");
    const devMode = localStorage.getItem("sandsDevMode");
    const now = Date.now();
    // if (
    //   !devMode &&
    //   lastPopupShown &&
    //   now - parseInt(lastPopupShown) < 24 * 60 * 60 * 1000
    // ) {
    //   return;
    // }
    // if (window.location.pathname !== "/") return;

    setTimeout(
        () => {
            const popup = document.querySelector(".sands-popup");
            popup.style.display = "flex";
            popup.style.opacity = "1";
            localStorage.setItem("sandsLastPopupShown", now.toString());
        },
        devMode ? 0 : 1000
    );
});
// document
//     .querySelector(".sands-popup > .invert")
//     .addEventListener("click", () => {
//         const popup = document.querySelector(".sands-popup");
//         if (popup.style.backgroundColor === "white") {
//             popup.style.backgroundColor = "black";
//             popup.style.color = "white";
//         } else {
//             popup.style.backgroundColor = "white";
//             popup.style.color = "black";
//         }
//     });